import { configureStore } from '@reduxjs/toolkit';
import userReducer from "../store/userSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,  
  },
});

// TypeScript types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
